import { useParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFetch, PageHeader, Badge, PAY_STATUS, Loading, ErrorBox } from "@/admin/ui";
import { PersonalTab, SubscriptionTab, ProgressTab, AccessTab, ConsumedTab } from "@/admin/StudentTabs";
import NotesTab from "@/admin/StudentNotes";

const TABS = [
  ["datos", "Datos personales", PersonalTab], ["suscripcion", "Suscripción", SubscriptionTab],
  ["progreso", "Progreso", ProgressTab], ["accesos", "Accesos", AccessTab], ["contenido", "Contenido consumido", ConsumedTab],
];

export default function StudentDetail() {
  const { id } = useParams();
  const { data, setData, error } = useFetch(`/admin/students/${id}`);
  if (error) return <ErrorBox />;
  if (!data) return <Loading />;
  return (
    <div data-testid="admin-student-detail">
      <PageHeader title={data.name} subtitle={data.email}>
        <Badge map={PAY_STATUS} value={data.pay_status} testid="admin-student-detail-status" />
        {data.role === "admin" && <span className="adm-badge info">Admin</span>}
      </PageHeader>
      <Tabs defaultValue="datos" className="adm-tabs">
        <TabsList className="flex-wrap h-auto">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-student-tab-${k}`}>{l}</TabsTrigger>)}
          <TabsTrigger value="notas" data-testid="admin-student-tab-notas">Notas internas</TabsTrigger>
        </TabsList>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-4"><C s={data} /></TabsContent>)}
        <TabsContent value="notas" className="mt-4">
          <NotesTab s={data} onChange={(notes) => setData({ ...data, notes })} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
